import {SimpleObjectPool} from "./SimpleObjectPool";
import {BS2} from "../BS2";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {BS2GameAssets} from "../BS2GameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";


/**
 * Created by jonas on 2020-08-14.
 */

export class GraphicsPool {
    private spinePoolMap:Map<string, SimpleObjectPool<PIXI.spine.Spine>>;
    private spritePoolMap:Map<string, SimpleObjectPool<PIXI.Sprite>>;
    private timeLineSpritePoolMap:Map<string, SimpleObjectPool<TimelineSprite>>;
    private genericPool:Map<string, SimpleObjectPool<any>>;
    public static SYMBOL_FRAME:string = "symbolFrame";

    constructor() {

        const noWinTint = PIXI.utils.string2hex("#888888");
        GraphicsPool.createSymbolTintTexture("M1", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("M2", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("M3", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("M4", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("M5", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("L1", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("L2", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("L3", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("L4", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("L5", "_noWin", noWinTint);

/*        GraphicsPool.createSymbolTintTexture("S1", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("S2", "_noWin", noWinTint);
        GraphicsPool.createSymbolTintTexture("WB", "_noWin", noWinTint);*/




        this.spinePoolMap = new Map();
        this.spritePoolMap = new Map();
        this.timeLineSpritePoolMap = new Map();
        this.genericPool = new Map();


        this.addSpinePool(BS2GameAssets.L1_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.L2_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.L3_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.L4_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.L5_SPINE, 3, 1, 25);

        this.addSpinePool(BS2GameAssets.M1_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.M2_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.M3_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.M4_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.M5_SPINE, 3, 1, 25);

        this.addSpinePool(BS2GameAssets.H1_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.H2_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.H3_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.H4_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.H5_SPINE, 3, 1, 25);

        this.addSpinePool(BS2GameAssets.D_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.G_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.W_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.S_SPINE, 3, 1, 25);
        this.addSpinePool(BS2GameAssets.Y_SPINE, 3, 1, 25);

        this.addSpinePool(BS2GameAssets.NEAR_WIN_SPINE, 5, 1, 5);

/*
        this.addSpinePool(BS2GameAssets.L_SPINE, 10, 1, 21);
        this.addSpinePool(BS2GameAssets.M1_SPINE, 3, 1, 21);
        this.addSpinePool(BS2GameAssets.M2_SPINE, 3, 1, 21);
        this.addSpinePool(BS2GameAssets.M3_SPINE, 3, 1, 21);
        this.addSpinePool(BS2GameAssets.M4_SPINE, 3, 1, 21);
        this.addSpinePool(BS2GameAssets.M5_SPINE, 3, 1, 21);
        this.addSpinePool(BS2GameAssets.S_SPINE, 3, 1, 21);
        this.addSpinePool(BS2GameAssets.WB_SPINE, 2, 1, 21);
        this.addSpinePool(BS2GameAssets.C_SPINE, 10, 1, 21);

        this.addSpinePool(BS2GameAssets.BOMB_SPINE, 2, 1, 21);
        this.addSpinePool(BS2GameAssets.GAS_SPINE, 2, 1, 21);
        this.addSpinePool(BS2GameAssets.COLLECTOR_SPINE, 2, 1, 21);
        this.addSpinePool(BS2GameAssets.PAYER_SPINE, 2, 1, 21);
        this.addSpinePool(BS2GameAssets.UPGRADE_SPINE, 2, 1, 21);
        this.addSpinePool(BS2GameAssets.MULTIPLIER_SPINE, 2, 1, 21);
*/



        //this.addSpinePool(BS2GameAssets.SMALL_EXPLOSION, 3, 1, 10);
        //this.addPool(this.genericPool, ()=>this.winFrameFactory(), GraphicsPool.SYMBOL_FRAME, 25,1); //.setLogLevel(LogLevel.INFO,true, true);
    }



/*    protected winFrameFactory():PIXI.Container {
        const frameSprite = new PIXI.NineSlicePlane(BS2.assetLoader.getTextures(BS2GameAssets.SYMBOL_GLOW_FRAME)[0], 32,32,32,32);
        const dotSprites:PIXI.Sprite[] = [
            new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.SYMBOL_GLOW_DOT)[0]),
            new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.SYMBOL_GLOW_DOT)[0]),
            new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.SYMBOL_GLOW_DOT)[0]),
            new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.SYMBOL_GLOW_DOT)[0])
        ]

        const sweepSprite = new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.SYMBOL_GLOW_SONAR_SWEEP)[0])

        const frame = new GlowFrame(frameSprite, dotSprites, sweepSprite);
        frame.spread.set(16, 16);
        frame.frameSize.set(144, 144);
        frame.pivot.set(66, 90);
        frame.position.set(66, 90);

        return frame;
    }*/

    private static createSymbolTintTexture(symbolName:string, suffix:string, tint:number) {
        const sprite = new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.getSymbolStateTexturePath(symbolName))[0]);
        sprite.tint = tint;

        const options = {
            width : sprite.width,
            height :sprite.height
        };

        const renderTexture:PIXI.RenderTexture = PIXI.RenderTexture.create(options);
        NolimitApplication.pixiApp.renderer.render(sprite, renderTexture);
        PIXI.Texture.addToCache(renderTexture, `${symbolName}/${symbolName}${suffix}`);
    }

    //-------------- SPINE
    public static spineFactory(name:string):PIXI.spine.Spine {
        const spine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(name));
        spine.update(0);
        return spine;
    }

    public addSpinePool(poolName:string, startSize:number, growRate:number = 1, maxSize?:number, assetName?:string):SimpleObjectPool<PIXI.spine.Spine> {
        return this.addPool(this.spinePoolMap, (name:string) => GraphicsPool.spineFactory(name), poolName, startSize, growRate, maxSize, assetName);
    }

    public getSpinePool(name:string):SimpleObjectPool<PIXI.spine.Spine> {
        return this.getPool(name, this.spinePoolMap);
    }

    //-------------- TIMLINE SPRITE
    private timLineSpriteFactory(name:string):TimelineSprite {
        return new TimelineSprite(BS2.assetLoader.getTextures(name), 30);
    }

    public addTimLineSpritePool(poolName:string, startSize:number, growRate:number = 1, maxSize?:number, assetName?:string):SimpleObjectPool<PIXI.Sprite> {
        return this.addPool(this.timeLineSpritePoolMap, (name:string) => this.timLineSpriteFactory(name), poolName, startSize, growRate, maxSize, assetName);
    }

    public getTimeLineSpritePool(name:string):SimpleObjectPool<TimelineSprite> {
        return this.getPool(name, this.timeLineSpritePoolMap);
    }


    //-------------- SPRITE
    private spriteFactory(name:string):PIXI.Sprite {
        return new PIXI.Sprite(BS2.assetLoader.getTextures(name)[0]);
    }

    public addSpritePool(poolName:string, startSize:number, growRate:number = 1, maxSize?:number, assetName?:string):SimpleObjectPool<PIXI.Sprite> {
        return this.addPool(this.spritePoolMap, (name:string) => this.spriteFactory(name), poolName, startSize, growRate, maxSize, assetName);
    }

    public getSpritePool(name:string):SimpleObjectPool<PIXI.Sprite> {
        return this.getPool(name, this.spritePoolMap);
    }

    public getGenericPool(name:string):SimpleObjectPool<any> {
        return this.getPool(name, this.genericPool);
    }



    //-------------- GENERIC
    private addPool(map:Map<any, any>, factory:(name:string) => any, poolName:string, startSize:number, growRate:number = 1, maxSize?:number, assetName?:string):SimpleObjectPool<any> {
        if (map.has(poolName)) {
            throw new Error("Pool already exist with name: " + poolName);
        }

        const asset = assetName == undefined ? poolName : assetName;
        const pool = new SimpleObjectPool<any>(
            poolName,
            () => {
                return factory(asset)
            },
            startSize,
            growRate,
            maxSize
        );


        map.set(poolName, pool);
        return pool;
    }

    private getPool(name:string, map:Map<any, any>):SimpleObjectPool<any> {
        const pool = map.get(name);
        if (pool == undefined) {
            throw new Error(`Cant find pool named:  ${name}`);
        }
        return pool;
    }



}